import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Service from "../pages/service/page";
import News from "../pages/news/page";
import Contact from "../pages/contact/page";
import Recruit from "../pages/recruit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/service",
    element: <Service />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/recruit",
    element: <Recruit />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
